/* eslint-disable import/prefer-default-export */
import graphqlClient from '../graphql';
import { listSystemItemTagsGql, upsertLineItemTagsGql } from './gql';

export const listLineItemTagsApi = () => {
  return graphqlClient
    .request(listSystemItemTagsGql)
    .then(({ listLineItemTags }) => listLineItemTags);
};

export const upsertLineItemTagsApi = ({ input }) => {
  return graphqlClient
    .request(upsertLineItemTagsGql, { input })
    .then(({ upsertLineItemTags }) => upsertLineItemTags);
};
